import { IPanelProps, Panel } from "core/decorators/Panel";
import React from "react";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import { SeparatorView } from "common/views/separator/Separator.view";
import Label from "core/components/label/Label";
import { BlockView } from "common/views/block/BlockView.view";
import CompletionFilterConfig from "./CompletionFilterConfig";

let defaultYearOptions = [{label:'All', value: 'All'}];
let yearOptions = [];

/**
 * Completion Filter Panel is used to filter results as per year
 *
 */
@Panel({ id: "Completion-filter", configClass: CompletionFilterConfig, pageParams: true })
export class CompletionFilterPanel extends React.Component<IPanelProps<CompletionFilterConfig>> {

	private onChangeField = (val) => {
		this.props.actions.pushPageParams({key: 'completedYear', value: val}, {key: 'pageNumber', value: 0});
	}

	public componentDidMount() {
		this.props.actions.pushPageParams({key: 'completedYear', value: new Date().getFullYear().toString()}, {key: 'pageNumber', value: 0});
	}

	public componentDidUpdate() {
		if (!this.props.pageParams.completedYear) {
			this.props.actions.pushPageParams({ key: 'completedYear', value: new Date().getFullYear().toString() }, { key: 'pageNumber', value: 0 });
		}
	}

	componentWillUnmount() {
		this.props.actions.removePageParams(["completedYear", "pageNumber"]);
	}

	private getYearOptions = () => {
		const currentYear = new Date().getFullYear();
			for (let i = 0; i < (this.props.config.lastYears || 5); i++) {
				const found = yearOptions.some((opt)=>opt.label === (currentYear - i).toString());
				if (!found) {
					yearOptions.push({label:(currentYear - i).toString(), value: (currentYear - i).toString()});
				}
			}
		return [...yearOptions, ...defaultYearOptions];
	}

	public render() {

		const {pageParams } = this.props;
		const { completedYear } = pageParams;
		let year = new Date().getFullYear().toString();
		if (completedYear) {
			year = completedYear;
		}

		return (
				<React.Fragment>
					<SeparatorView viewKey="select-separator" />
					<BlockView viewKey="dropdown">
						<div style={{display: 'flex'}}>
							<Label k="completion.filter.message" v="Completion by year:" />
							<DropdownSelect
								buttonProps={{
									minimal: true,
									small: true,
								}}
								options={this.getYearOptions()}
								value={year}
								onChange={(val)=>this.onChangeField(val)}
							/>
						</div>
					</BlockView>
				</React.Fragment>
		)
	}
}


// WEBPACK FOOTER //
// ./src/panels/subscriptions/CompletionFilter.panel.tsx